import type { FieldIdentifier, InputFormProps } from '../../../interfaces'
import DateInputForm from './DateInputForm'
import DimensionsInputForm from './DimensionsInputForm'
import FormatInputForm from './FormatInputForm'
import KeywordsInputForm from './KeywordsInputForm'
import NameInputForm from './NameInputForm'
import PrivacyInputForm from './PrivacyInputForm'
import PublishInputForm from './PublishInputForm'
import SizeInputForm from './SizeInputForm'
import TagsInputForm from './TagsInputForm'
import TransparencyInputForm from './TransparencyInputForm'
import LocationInputForm from './LocationInputForm'
import PathInputForm from './PathInputForm'
import IdInputForm from './IdInputForm'
import {
  CustomMetadataTextInputForm,
  CustomMetadataDateInputForm,
  CustomMetadataSelectInputForm,
  CustomMetadataBooleanInputForm,
  CustomMetadataNumberInputField,
} from './CustomMetadataForms'

const getInputForm = ({
  fieldName,
  customMetadataField,
}: FieldIdentifier): ((props: InputFormProps) => React.ReactElement) => {
  if (fieldName) {
    if (fieldName === 'name') {
      return NameInputForm
    }
    if (fieldName === 'tags') {
      return TagsInputForm
    }
    if (fieldName === 'format') {
      return FormatInputForm
    }
    if (fieldName === 'private') {
      return PrivacyInputForm
    }
    if (fieldName === 'published') {
      return PublishInputForm
    }
    if (fieldName === 'transparency') {
      return TransparencyInputForm
    }
    if (fieldName === 'size') {
      return SizeInputForm
    }
    if (fieldName === 'dimensions') {
      return DimensionsInputForm
    }
    if (
      [
        'createdAt',
        'updatedAt',
        '"embeddedMetadata.DateTimeOriginal"',
      ].includes(fieldName)
    ) {
      return DateInputForm
    }
    if (fieldName === '"embeddedMetadata.Keywords"') {
      return KeywordsInputForm
    }
    if (fieldName === '"embeddedMetadata.LocationTaken"') {
      return LocationInputForm
    }
    if (fieldName === 'path') {
      return PathInputForm
    }
    if (fieldName === 'id') {
      return IdInputForm
    }
  }

  if (customMetadataField?.schema) {
    if (['Text', 'Textarea'].includes(customMetadataField.schema.type)) {
      return CustomMetadataTextInputForm
    }

    if (customMetadataField.schema.type === 'Date') {
      return CustomMetadataDateInputForm
    }

    if (customMetadataField.schema.type === 'Boolean') {
      return CustomMetadataBooleanInputForm
    }

    if (customMetadataField.schema.type === 'Number') {
      return CustomMetadataNumberInputField
    }

    if (
      ['SingleSelect', 'MultiSelect'].includes(customMetadataField.schema.type)
    ) {
      return CustomMetadataSelectInputForm
    }
  }
  return NameInputForm
}

export { getInputForm }
